import { render, staticRenderFns } from "./ArticleMain.vue?vue&type=template&id=492e2f6c&"
import script from "./ArticleMain.vue?vue&type=script&lang=js&"
export * from "./ArticleMain.vue?vue&type=script&lang=js&"
import style0 from "./ArticleMain.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports